// extracted by mini-css-extract-plugin
export default {"card":"teammembercard_card__zKYuT","img":"teammembercard_img__08657"};